/**
 * Created by Mark on 05/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import {PieChart, Pie, Sector}  from 'recharts';

const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
        fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
                />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
                />
            <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
            <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#ffffff">{`${value}`}</text>
        </g>
    );
};

export default class BarGraph extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {
            id: this.props.id || Math.random(),
            index: this.props.index || 0,
            dataKeys:  [{key:'reading' , fill:'#fd470a'} , {key:'listening' , fill:'#ff8417'} , {key:'writing' , fill:'#fa74b7'} , {key:'speaking' , fill:'#1b9ff6'}],
            height:this.props.height || 100,
            data:this.props.data || [{name: '' , value: 100 , fill:"#ffffff" }, {name: '' , value: 300 , fill:"none"}]
        }

        this.updateDimensions  =   this.updateDimensions.bind(this)
    }

    updateDimensions(){

        console.log(document.getElementById(this.state.id).clientWidth);
        this.setState({
            width:document.getElementById(this.state.id).clientWidth,
        })
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize"   , this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }


    render(){
        return(
            <div id={this.state.id}>
                <PieChart width={this.state.width} height={this.state.height} >
                    <Pie
                        activeIndex={this.state.index}

                        data={this.state.data}
                        cx={this.state.width/2}
                        cy={this.state.height/2}
                        innerRadius={(this.state.height/2)*0.6}
                        outerRadius={(this.state.height/2)*0.7}/>
                </PieChart>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/graphs/PieGraph.js